import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { typographyVariantMapping } from "../theme";
import { BaseComponent } from "./BaseComponent";
export const typographyClasses = {
    root: "MinervaTypography-root",
    truncate: "MinervaTypography-truncate",
};
export const typographyFontWeights = ["bold", "semibold", "regular"];
export const typographyTextTransforms = ["uppercase", "lowercase", "capitalize", "none"];
export const typographyAlignments = ["start", "left", "center", "right", "end", "justify"];
const getMaxFontSize = (theme, variant) => {
    const maxFontSize = theme.typography.maxMobileFontSize
        ? Number.parseFloat(theme.typography.maxMobileFontSize)
        : 0;
    const fontSize = Number.parseFloat(theme.typography[variant].fontSize);
    return fontSize <= maxFontSize
        ? theme.typography[variant].fontSize
        : theme.typography.maxMobileFontSize ?? "2rem";
};
export const Typography = memo(forwardRef((props, ref) => {
    const { variant = "body1", fontWeight, textTransform, align, breakAll, truncate, width, textColor, bgColor, color, colorSet, invertColors, className, sx, as, ...rest } = useDefaultProps({ component: "Typography", props });
    return (_jsx(ColorsProvider, { color: color, textColor: textColor, bgColor: bgColor, colorSet: colorSet, invertColors: !invertColors, children: ({ color }) => (_jsx(BaseComponent, { ref: ref, className: clsx([
                typographyClasses.root,
                truncate && typographyClasses.truncate,
                className,
            ]), as: as ?? typographyVariantMapping[variant ?? "body1"] ?? "p", sx: mergeSx({
                color,
                width,
                lineHeight: "normal",
                textTransform,
                textAlign: align,
                wordBreak: breakAll ? "break-all" : undefined,
                fontFamily: (theme) => theme.typography[variant ?? "body1"].fontFamily,
                fontWeight: (theme) => fontWeight === "bold"
                    ? theme.typography.fontWeightBold
                    : fontWeight === "semibold"
                        ? theme.typography.fontWeightSemiBold
                        : theme.typography.fontWeightRegular,
                marginBlockStart: 0,
                marginBlockEnd: 0,
                [`&.${typographyClasses.truncate}`]: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                },
                breakpoints: {
                    xs: {
                        fontSize: (theme) => getMaxFontSize(theme, variant ?? "body1"),
                    },
                    md: {
                        fontSize: (theme) => theme.typography[variant ?? "body1"].fontSize,
                    },
                },
            }, sx), ...rest })) }));
}));
//# sourceMappingURL=Typography.js.map